// Auto-generated address book for chain 1 (scripts/deployLocal.cjs writes this per deploy).
// One book per chain; src/lib/contracts.js selects among them by VITE_TARGET_CHAIN, so mainnet,
// Sepolia and local hardhat no longer overwrite one another in a single shared file.
// Mainnet is NOT live yet: IS_DEPLOYED=false and every address is zeroed on purpose.
export const IS_DEPLOYED = false;
export const CHAIN_ID = 1;
export const ADDRESSES = {
  HORIZON_TOKEN:      "0x0000000000000000000000000000000000000000",
  // Testnet-only public HORIZON faucet (zero address on mainnet / any non-DEPLOY_FAUCET run). The
  // dapp's "Get test tokens" panel shows a drip button only when this is set.
  HORIZON_FAUCET:     "0x0000000000000000000000000000000000000000",
  HORIZON_EMISSIONS:  "0x0000000000000000000000000000000000000000",
  // The HORIZON/USDx Uniswap V3 pool. Recorded directly rather than resolved through whatever
  // happens to hold liquidity in it, because it is this app's ONLY HORIZON/USD price signal
  // (useHorizonPriceUsd) and that signal must outlive any one consumer - it was previously read
  // off the LP farm's farm-0 struct, which tied the whole app's USD pricing to a contract now
  // being retired. The pool itself is permanent; the things holding positions in it are not.
  HORIZON_WETH_POOL:  "0x0000000000000000000000000000000000000000",
  USDX:            "0x0000000000000000000000000000000000000000",
  hUSD:            "0x0000000000000000000000000000000000000000",
  WETH:            "0x0000000000000000000000000000000000000000",
  SWAP_ROUTER:     "0x0000000000000000000000000000000000000000",
  NPM:             "0x0000000000000000000000000000000000000000",
  LENDING_POOL:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_USDX:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_hUSD:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_WETH:    "0x0000000000000000000000000000000000000000",
  // Blue-chip collaterals listed alongside WETH, both NON-isolated (shared-risk pool). WBTC is
  // 8-decimal - the frontend reads every reserve's decimals off-chain rather than assuming.
  WBTC:            "0x0000000000000000000000000000000000000000",
  S_TOKEN_WBTC:    "0x0000000000000000000000000000000000000000",
  // Recorded even though the frontend enumerates reserves from the chain: scripts resolve
  // external assets through this block (devSeedPairVenue's COLLATERAL=usdc, applyLoopVenues).
  USDC:            "0x0000000000000000000000000000000000000000",
  WSTETH:          "0x0000000000000000000000000000000000000000",
  S_TOKEN_WSTETH:  "0x0000000000000000000000000000000000000000",
  // wstETH/USD is a COMPOSED feed (stETH/USD x the live Lido rate), deployed by this script rather
  // than a canonical mainnet address - recorded so the checklist and any verifier can find it.
  WSTETH_USD_FEED: "0x0000000000000000000000000000000000000000",
  // USDx's own price feed. Recorded because config/reserves.json references it as $USDX_FEED -
  // a protocol-deployed feed whose address changes every redeploy, so it cannot be pinned there.
  USDX_FEED:       "0x0000000000000000000000000000000000000000",
  WETH_GATEWAY:    "0x0000000000000000000000000000000000000000",
  // Native-coin deposits into ALM vaults (the vault-side counterpart to WETH_GATEWAY). Per chain,
  // this is the ONLY address that changes; the frontend reads it here and shows the native deposit
  // option on any vault whose pair holds the wrapped-native. See NativeVaultZap.sol.
  NATIVE_VAULT_ZAP: "0x0000000000000000000000000000000000000000",
  HORIZON_VOTE_ESCROW: "0x0000000000000000000000000000000000000000",
  HORIZON_REVENUE_DISTRIBUTOR: "0x0000000000000000000000000000000000000000",
  REVENUE_ROUTER:  "0x0000000000000000000000000000000000000000",
  BUYBACK:         "0x0000000000000000000000000000000000000000",
  REFERRAL_REGISTRY: "0x0000000000000000000000000000000000000000",
  // Guardian Pools - one SafetyModule proxy per reserve (entry 165), each defending its own debt
  // market. SAFETY_MODULE_<ASSET> keying matches S_TOKEN_<ASSET>'s own convention; the lines are
  // GENERATED from the same catalogue-derived set 8b deployed, so a sixth reserve records its
  // module here without anyone editing this template.
  SAFETY_MODULE_WETH: "0x0000000000000000000000000000000000000000",
  SAFETY_MODULE_USDC: "0x0000000000000000000000000000000000000000",
  // First-loss cover pool (Feature 5, entry 214) - per COVER ASSET, not per reserve; underwrites
  // coverage lines for future protected products. Backend primitive only for now, no frontend
  // surface until the first senior product ships (Phase C, post-audit).
  FIRST_LOSS_VAULT_USDX: "0x0000000000000000000000000000000000000000",
  // Integration surfaces - immutable, stateless, no protocol authority. POOL_VIEWS is the
  // Aave-shaped read surface liquidation bots build against; WRAPPED_SUSDX is the ERC-4626
  // adapter yield aggregators discover by scanning for the standard.
  POOL_VIEWS:      "0x0000000000000000000000000000000000000000",
  WRAPPED_SUSDX:   "0x0000000000000000000000000000000000000000",
  // D1 (entry 208): the rest of the supply side's 4626 doorways + the vaults' lens, both
  // catalogue-derived - generated lines, like the guardian modules above.
  WRAPPED_SWETH: "0x0000000000000000000000000000000000000000",
  WRAPPED_SUSDC: "0x0000000000000000000000000000000000000000",
  VAULT_LENS:      "0x0000000000000000000000000000000000000000",
  // Leveraged looping, periphery only - holds no user funds between transactions and has no
  // pool privilege; each user delegates to it themselves.
  MULTIPLY_ROUTER: "0x0000000000000000000000000000000000000000",
  // Opt-in liquidation protection. Periphery, immutable, and it moves a user's collateral ONLY
  // while that user's own health factor sits below the trigger they set - so the app must read
  // per-user settings off it rather than assume anything protocol-wide.
  PROTECTION_MANAGER: "0x0000000000000000000000000000000000000000",
  // Vault system - shared infrastructure only (see step 10's own doc comment); no vault instance
  // is created by this script, so there is no VAULT_/individual-vault address to record here.
  POOL_MANAGER:       "0x0000000000000000000000000000000000000000",
  VAULT_ORACLE_HOOK:  "0x0000000000000000000000000000000000000000",
  VAULT_BEACON_V3:    "0x0000000000000000000000000000000000000000",
  VAULT_BEACON_V4:    "0x0000000000000000000000000000000000000000",
  REBALANCE_GUARD:    "0x0000000000000000000000000000000000000000",
  VAULT_FEE_MANAGER:  "0x0000000000000000000000000000000000000000",
  CLEARING_V3:        "0x0000000000000000000000000000000000000000",
  CLEARING_V4:        "0x0000000000000000000000000000000000000000",
  VAULT_FACTORY:      "0x0000000000000000000000000000000000000000",
  // Single-asset staking registry. The app enumerates this rather than carrying a hardcoded list,
  // so listing an asset is a genesis transaction and needs no frontend deploy. Deployed here (step
  // 10b) precisely so it survives a redeploy - it used to be created only by
  // scripts/createStakingVault.cjs and had to be pasted back in by hand every time.
  STAKING_VAULT_FACTORY: "0x0000000000000000000000000000000000000000",
  // Deploy block of HorizonLendingPool - the Liquidations page's event-log scan (useAllBorrowers)
  // starts from here, not block 0, since a mainnet-fork chain inherits the real chain's full
  // height and forked RPC providers commonly cap eth_getLogs to a bounded block range (e.g.
  // 50,000 blocks) - scanning from literal genesis fails outright on a fork.
  LENDING_POOL_DEPLOY_BLOCK: "0",
};
